import { Link } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

export default function AdminDashboard() {
  const queryClient = useQueryClient();
  const [email, setEmail] = useState("");

  const { isLoading } = useQuery({
    queryKey: ["admin-email"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/settings/admin-email`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("bigBearJWTToken")}`,
          },
        }
      );
      const data = await res.json();
      setEmail(data.email);
      return data;
    },
  });

  const updateEmailMutation = useMutation({
    mutationFn: async (email: string) => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/settings/admin-email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("bigBearJWTToken")}`,
          },
          body: JSON.stringify({ email }),
        }
      );
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-email"] });
    },
  });

  return (
    <div className="flex justify-center px-4 py-16">
      <div className="w-full max-w-md text-center">
        <h1 className="text-3xl font-bold text-[#006838] mb-6">
          Admin Dashboard
        </h1>

        <Link
          to="/admin/bookings"
          className="inline-block rounded-md bg-[#006838] px-6 py-3 text-white text-sm font-medium hover:bg-green-800 transition"
        >
          View Bookings
        </Link>

        <div className="mt-10 text-left">
          <h2 className="text-lg font-semibold mb-2">
            Admin Notification Email
          </h2>

          <p className="text-sm text-gray-600 mb-4">
            This email address will receive notifications whenever a guest
            submits a new request. Make sure it's up to date so you don't miss
            any messages.
          </p>

          {isLoading ? (
            <p className="text-sm text-gray-500">Loading email...</p>
          ) : (
            <form
              className="space-y-3"
              onSubmit={(e) => {
                e.preventDefault();
                updateEmailMutation.mutate(email);
              }}
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full border px-3 py-2 rounded-md text-sm"
              />
              <button
                type="submit"
                disabled={updateEmailMutation.isPending}
                className="w-full bg-[#006838] text-white px-4 py-2 rounded-md hover:bg-green-800 transition disabled:opacity-50 text-sm"
              >
                {updateEmailMutation.isPending ? "Saving..." : "Save Email"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
